export const initialState={
    cart:[],
    isLoggedIn:false,
};

const reducer =(state,action)=>{
    
    switch (action.type){
        case "ADD_TO_CART":
          return {
              ...state,
              cart: [...state.cart,action.item],
          }
          case "REMOVE_FROM_CART":
            
                    const index = state.cart.findIndex(
                     (cartitem) => cartitem.title === action.title
                    );
                    let newCart = [...state.cart];
                     if (index >= 0) {
                            newCart.splice(index, 1);
                          } else {
                  console.warn("Cannot remove product. Not in cart");
                      }
                       return {
                         ...state,
                         cart: newCart,
      
              }
              case "login":
                  const status=action.status;
                  return{
                     isLoggedIn:{status},
                  }
          default:
              return state;

    }
}
export default reducer;